import { z } from 'zod';

export enum ContactsListSearchKey {
  SEARCH = 'search',
  INCLUDE_INACTIVE = 'includeInactive',
}

export const ContactsListSearchParams = z.object({
  [ContactsListSearchKey.SEARCH]: z.string().optional(),
  [ContactsListSearchKey.INCLUDE_INACTIVE]: z.custom<boolean>().optional(),
});

export type ContactsListSearchParams = z.infer<typeof ContactsListSearchParams>;
